import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { strings } from './Contact.strings'
import { FaFacebook, FaInstagram } from 'react-icons/fa'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2em;
  max-width: 1000px;
  margin: 0 auto;
  padding: 2em;
`

const SupportSection = styled.div`
  text-align: center;

  > p {
    color: ${({ theme }) => theme.colors.font.subdued};
    margin: 1em 0;
  }

  > a {
    color: ${({ theme }) => theme.colors.brand.primary.regular};
    text-decoration: none;
    font-weight: bold;

    &:hover {
      text-decoration: underline;
    }
  }
`

const FAQSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2em;
`

const FAQItem = styled.div`
  border-radius: 12px;
  padding: 1.5em;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  > h3 {
    color: ${({ theme }) => theme.colors.font.regular};
    margin-bottom: 0.5em;
  }

  > p {
    color: ${({ theme }) => theme.colors.font.subdued};
    font-family: ${({ theme }) => theme.fonts.primary};
  }
`

const SocialSection = styled.div`
  text-align: center;

  > h2 {
    margin-bottom: 1em;
  }

  > p {
    color: ${({ theme }) => theme.colors.font.subdued};
    margin-bottom: 1.5em;
  }
`

const SocialLinks = styled.div`
  display: flex;
  gap: 2em;
  justify-content: center;

  > a {
    color: ${({ theme }) => theme.colors.brand.primary.regular};
    font-size: 2em;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.1);
    }
  }
`

export const Contact: React.FC = () => {
  return (
    <Container>
      <SupportSection>
        <h1>
          <FormattedMessage {...strings.header} />
        </h1>
        <p>
          <FormattedMessage {...strings.supportMessage} />
        </p>
        <p>
          <FormattedMessage {...strings.emailUs} />{' '}
          <a href="mailto:support@partyguestbook.com">
            support@partyguestbook.com
          </a>
        </p>
      </SupportSection>

      <FAQSection>
        <h2>
          <FormattedMessage {...strings.faqTitle} />
        </h2>
        <FAQItem>
          <h3>
            <FormattedMessage {...strings.faq1Question} />
          </h3>
          <p>
            <FormattedMessage {...strings.faq1Answer} />
          </p>
        </FAQItem>
        <FAQItem>
          <h3>
            <FormattedMessage {...strings.faq2Question} />
          </h3>
          <p>
            <FormattedMessage {...strings.faq2Answer} />
          </p>
        </FAQItem>
        <FAQItem>
          <h3>
            <FormattedMessage {...strings.faq3Question} />
          </h3>
          <p>
            <FormattedMessage {...strings.faq3Answer} />
          </p>
        </FAQItem>
        <FAQItem>
          <h3>
            <FormattedMessage {...strings.faq4Question} />
          </h3>
          <p>
            <FormattedMessage {...strings.faq4Answer} />
          </p>
        </FAQItem>
      </FAQSection>

      <SocialSection>
        <h2>
          <FormattedMessage {...strings.socialTitle} />
        </h2>
        <p>
          <FormattedMessage {...strings.socialMessage} />
        </p>
        <SocialLinks>
          <a
            href="https://facebook.com/partyguestbook"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FaFacebook />
          </a>
          <a
            href="https://instagram.com/partyguestbook"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
        </SocialLinks>
      </SocialSection>
    </Container>
  )
}
